import {  ClientDetails } from './../../../AML/aml-modal';
import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ClientReview } from '../../../AML/aml-modal';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-group-client-account-table',
  templateUrl: './group-client-account-table.component.html',
  standalone :false,
  styleUrls: ['./group-client-account-table.component.scss']
})
export class GroupClientAccountTableComponent implements OnInit,AfterViewInit {
  ngAfterViewInit(): void {
  
  }
  @Input() dataSource: MatTableDataSource<ClientReview> = new MatTableDataSource<ClientReview>(); // Input for table data


  @Input() displayedColumns: string[] = []; // Input for parent table columns
  @Input() clientColumns: string[] = []; // Input for nested client table columns
  @Input() accountColumns: string[] = []; // Input for nested account table columns

  @Output() selectedGroup = new EventEmitter<ClientReview>(); // Output for selected group
  @Output() selectedClients = new EventEmitter<ClientDetails[]>(); // Output for selected clients

  paginatedDataSource: any[] = []; // Data for the current page
  pageSize = 100; // Default page size
  currentPage = 0; // Current page index
  isNoData = false; // Flag for no data
  private mainRowIndex = 0; //
  totalData :number=0;
  pageNo = 1;
  checkedClients: ClientDetails[] = []; // Track all selected clients

  ngOnInit(): void {
     
    this.isNoData = this.dataSource.data.length === 0;
    this.totalData=this.dataSource.data.length;
    this.updatePaginatedDataSource();

     console.log('Grouped Data:hjhhhhhhhh', this.dataSource.data);
  }

  toggleExpand(element: any): void {
    element.expanded = !element.expanded;
  }

  onGroupCheckboxChange(group: any, event: any): void {
    const isChecked = event.checked;

    // Set the group's selected state
    group.selected = isChecked;

    // Select or deselect all clients in the group
    if (group.clientDetails) {
      group.clientDetails.forEach((client: any) => {
        client.selected = isChecked;
      });
    }

    // Emit the selected group
    this.selectedGroup.emit(group);
  }

  onClientCheckboxChange(eve:MatCheckboxChange,group:ClientReview,client: ClientDetails): void {
   
    if (eve.checked) {
      // Add the client to the selected list
      this.checkedClients.push(client);
    } else {
      // Remove the client from the selected list
      this.checkedClients = this.checkedClients.filter(selected => selected !== client);
    }

    // Emit the updated list of selected clients
    this.selectedClients.emit(this.checkedClients);
  }

  isAllGroupsSelected(): boolean {
    return this.dataSource.data.every((group: any) => group.selected);
  }

  isSomeGroupsSelected(): boolean {
    return this.dataSource.data.some((group: any) => group.selected) && !this.isAllGroupsSelected();
  }

  onMasterCheckboxChange(event: any): void {
    const isChecked = event.checked;

    // Select or deselect all groups
    this.dataSource.data.forEach((group: any) => {
      group.selected = isChecked;

      // Select or deselect all clients in the group
      if (group.clientDetails) {
        group.clientDetails.forEach((client: any) => {
          client.selected = isChecked;
        });
      }
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePaginatedDataSource();
  }

  updatePaginatedDataSource(): void {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedDataSource = this.dataSource.data.slice(startIndex, endIndex);
  }

 getRowClass(index: number, element: any): any {
  if (element.expanded) {
    return '';
  }
  const rowClass = this.mainRowIndex % 2 === 0 ? 'even-row' : 'odd-row';
  this.mainRowIndex++;
  return {
    'even-row': rowClass === 'even-row',
    'odd-row': rowClass === 'odd-row',
    'dup-orders': element['isDup']
  };
}

public handlePageEvents(e: PageEvent) {
  setTimeout(() => {
    this.pageNo = e.pageIndex + 1;
    this.pageSize = e.pageSize;
  
//this.fetchClientReviews();

   
  
  });
}
}